import React, { useState } from 'react';
import './MeetingSummary.css';
import { useActions } from '../contexts/ActionsContext';

const MeetingSummary = ({ meetings, accountKey, accountName, currentMeetingIndex, onMeetingSelect, onActionToggle }) => {
  const [activeTab, setActiveTab] = useState('notes');
  const { actions, toggleActionComplete } = useActions();
  const currentMeeting = meetings[currentMeetingIndex];
  
  // Filter actions that belong to this account
  const accountActions = actions.filter(action => action.accountName === accountName);

  const renderContent = () => {
    switch(activeTab) {
      case 'notes':
        return <div className="meeting-content">{currentMeeting.notes}</div>;
      
      case 'actions':
        return (
          <div className="meeting-content">
            {accountActions.length > 0 ? (
              accountActions.map((action) => (
                <div key={action.id} className="action-item">
                  <input 
                    type="checkbox" 
                    className="action-checkbox"
                    id={`action-${action.id}`}
                    checked={action.completed}
                    onChange={() => toggleActionComplete(action.id)}
                  />
                  <label 
                    htmlFor={`action-${action.id}`}
                    className={`action-text ${action.completed ? 'completed' : ''}`}
                  >
                    {action.text}
                  </label>
                  <span className="action-meta">
                    {action.priority && ` • Priority: ${action.priority}`}
                    {action.status && ` • Status: ${action.status}`}
                  </span>
                </div>
              ))
            ) : (
              <div className="no-actions">No actions for this account</div>
            )}
          </div>
        );
      
      case 'transcript':
        return <div className="meeting-content">{currentMeeting.transcript}</div>;
      
      default:
        return null;
    }
  };

  return (
    <div className="meeting-summary">
      <h4>Meeting Summaries</h4>
      
      <div className="meeting-selector">
        {meetings.map((meeting, index) => (
          <button
            key={index}
            className={`meeting-date-btn ${index === currentMeetingIndex ? 'active' : ''}`}
            onClick={() => onMeetingSelect(index)}
          >
            {meeting.date}
          </button>
        ))}
      </div>

      <div className="meeting-buttons">
        <button 
          className={`meeting-button ${activeTab === 'notes' ? 'active' : ''}`}
          onClick={() => setActiveTab('notes')}
        >
          Notes
        </button>
        <button 
          className={`meeting-button ${activeTab === 'actions' ? 'active' : ''}`}
          onClick={() => setActiveTab('actions')}
        >
          Actions
        </button>
        <button 
          className={`meeting-button ${activeTab === 'transcript' ? 'active' : ''}`}
          onClick={() => setActiveTab('transcript')}
        >
          Transcript
        </button>
      </div>

      {renderContent()}
    </div>
  );
};

export default MeetingSummary;